import { render, staticRenderFns } from "./DaMoral.vue?vue&type=template&id=0c54b6c3&"
import script from "./DaMoral.vue?vue&type=script&lang=js&"
export * from "./DaMoral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports